export default __webpack_public_path__ + "static/media/media-empty.0f4ff2f2.svg";